import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { Info } from "material-ui-icons";

const tabs = [
  { label: "My MedMeetings", url: "my" },
  { label: "All Other MedMeetings", url: "all" },
];

class StudyGroupSuperhostWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };
  }

  render() {
    const { location } = this.props;

    const { isHovered } = this.state;

    return (
      <main style={{ minHeight: "auto" }}>
        <h4 className="groups-title">
          <div>WELCOME TO MEDMEETINGS</div>
          {/* <div style={{ position: "relative" }}>
            <Info
              onMouseEnter={() => this.setState({ isHovered: true })}
              onMouseLeave={() => this.setState({ isHovered: false })}
              style={{ color: "#2d98de", fontSize: 32, cursor: "pointer" }}
            />
            {isHovered && (
              <div className="groups-info-hover">
                MedMeetings gives MedCafe members exclusive access to
                member-only meetings and resources. Click the ‘Request to Join’
                button to request to be added.
              </div>
            )}
          </div> */}
        </h4>
        <StudyGroupUserNavigation tabs={tabs} activeUrl={location.pathname} />
        {this.props.children}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperhostWrapper);

class StudyGroupUserNavigation extends Component {
  render() {
    const { tabs, activeUrl } = this.props;

    const getUrl = (url) => `/groups/${url}`;

    const isUrlActive = (url) => activeUrl.includes(url);

    return (
      <div className="group-navigation">
        {tabs.map(({ label, url }, idx) => (
          <Link
            className={`group_button groups-navigation-button ${
              isUrlActive(url) && "active"
            }`}
            to={getUrl(url)}
            key={idx}
          >
            {label}
          </Link>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/StudyGroupsSuperhost/StudyGroupSuperhostWrapper.jsx